import { UntypedFormControl } from '@angular/forms';
import { IFormularioResposta } from '@app/modules/formulario/model/formulario_resposta/formulario_resposta.model';
import { IMaterial } from '@app/modules/material/model';
import { IPaciente } from '@app/modules/paciente/models/paciente.model';
import { IPedido } from '@app/modules/pedidos/model/pedido.model';
import { IProcedimento } from '@app/modules/procedimento/models/procedimento.model';
import { IProfissional } from '@app/modules/profissional/models/profissional.model';
import { ITratamento } from '@app/modules/tratamentos/models/tratamento.model';
import { IEntity } from 'viggo-sistemas-core-web';
import { ILocalAgendamento } from './local_agendamento.model';

export const ordemDataHora = (
  a: CALENDAR_EVENT_AGENDAMENTO,
  b: CALENDAR_EVENT_AGENDAMENTO
) => (new Date(a.data_hora) > new Date(b.data_hora) ? 1 : -1);

export interface CALENDAR_EVENT_AGENDAMENTO {
  total: number;
  paciente: string;
  color: string;
  local_agendamento: string;
  data_hora: Date | string;
}

export enum AGENDAMENTO_STATUS {
  CRIADO = 'CRIADO',
  CONCLUIDA = 'CONCLUIDA',
  CANCELADA = 'CANCELADA',
  EM_ANDAMENTO = 'EM_ANDAMENTO'
}

export enum AGENDAMENTO_TIPO {
  AVALIACAO = 'AVALIAÇÃO',
  EVOLUCAO = 'EVOLUÇÃO'
}

export interface IAgendamentoEvento {
  status: AGENDAMENTO_STATUS | string;
  status_at: Date | string;
  status_by: string;
  agendamento_id?: string;
  motivo_cancelamento_id?: string;
  observacao?: string;
}

export interface IAgendamentoProcedimento {
  id: string;
  agendamento_id: string;
  procedimento_id: string;
  procedimento?: IProcedimento;
  item?: number;
}

export interface IAgendamentoSessao {
  qtd_visitas: number; // 3
  valor_visita: number; // 15,2
  valor_adicional: number; // 15,2
  descricao_valor_adicional: string;
}

export interface IAgendamentoMaterial {
  id: string;
  quantidade: number; // numeric 16,3
  valor: number; // 15,2
  material_id: string;
  agendamento_id: string;
  material?: IMaterial;
  item?: number;
  formControl?: UntypedFormControl;
}

export interface IAgendamentoMaterialVenda {
  id: string;
  material_id: string;
  qtd: number; // 16,3
  valor: number; // 15,2
  item?: number;
  material?: IMaterial;
}
export interface IAgendamento extends IEntity {
  domain_id: string;
  eventos: IAgendamentoEvento[];
  local_agendamento_id: string;
  paciente_id: string;
  tratamento_id: string;
  profissional_id: string;
  formulario_resposta_id: string;
  observacao: string; // 2000
  objetivo: string; // 2000
  status: AGENDAMENTO_STATUS | string;
  tipo: AGENDAMENTO_TIPO | string;
  tempo_atendimento: number; // numeric 4
  data_hora: Date | string;
  paciente?: IPaciente;
  profissional?: IProfissional;
  tratamento?: ITratamento;
  formulario_resposta?: IFormularioResposta;
  local_agendamento?: ILocalAgendamento;
  nome_paciente?: string;
  nome_profissional?: string;
  qtd_agendamentos?: string;
  pedido?: IPedido;
  pedido_id?: string;
  procedimentos?: IAgendamentoProcedimento[];
  materiais?: IAgendamentoMaterial[];
  materiaisVenda?: IAgendamentoMaterialVenda[];
}
